// extracted by mini-css-extract-plugin
export var button = "_bn-0";
export var icon = "_bn-1";